type useNuDataApi = {
  beginBehaviouralMonitoring: () => void;
  clearBehaviouralData: () => void;
  stopBehaviouralMonitoring: () => void;
  getBehaviouralData: () => string;
  getSessionId: () => string;
};

export function useNuData(): useNuDataApi {
  const nds = window.ndsapi || (window.ndsapi = {});
  const ndsReadyCallback =
    window.ndsReadyCallback || (window.ndsReadyCallback = []);
  let nudataNds = '';
  let nuDataStarted = false;

  const requestCall = (callback: () => void) => {
    if (window.ndsReady) {
      callback();
    } else {
      ndsReadyCallback.push(callback);
    }
  };

  const beginBehaviouralMonitoring = () => {
    if (nuDataStarted) {
      return;
    }

    const callback = function () {
      nds.bindNewFields();
    };

    requestCall(callback);
    nuDataStarted = true;
  };

  const stopBehaviouralMonitoring = () => {
    const callback = function () {
      nds.stop();
    };

    saveBehaviouralData();
    requestCall(callback);
    nuDataStarted = false;
  };

  const clearBehaviouralData = () => {
    const callback = function () {
      nds.clear();
    };

    requestCall(callback);
  };

  const saveBehaviouralData = () => {
    const ndspmdNode = document.getElementsByName('nds-pmd').item(0);
    const ndspmdValue = ndspmdNode
      ? (ndspmdNode as HTMLInputElement).value
      : '';
    if (ndspmdValue) {
      nudataNds = ndspmdValue;
    }
  };

  const getBehaviouralData = () => {
    return nudataNds;
  };

  const getSessionId = () => {
    return window.ndsapi?.config?.sessionId || '';
  };

  return {
    beginBehaviouralMonitoring,
    clearBehaviouralData,
    stopBehaviouralMonitoring,
    getBehaviouralData,
    getSessionId,
  };
}
